"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverDescription_PopoverDescription = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = usePopoverMode();
    const { description } = popoverVariants();
    const classes = cn(description(), className, slots?.description);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Description, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Popover.Description, {
        ref: ref,
        className: classes,
        ...props
    });
});
export { PopoverDescription_PopoverDescription as PopoverDescription };
